import React from 'react'
import CRUD from '../../components/common/CRUD/CRUD'
import { fields } from '../../models/materialResources/itemModel'
import { createCRUDService } from '../../services/crudService'
import { Breadcrumb } from 'react-bootstrap'

const ItemsView = () => {
  const { listItems, deleteItem, createItem, updateItem } = createCRUDService(
    '/api/material_resources/items'
  )
  return (
    <main style={{ padding: '1rem 0' }}>
      <CRUD
        fields={fields}
        entityName='Artículo'
        paginated
        dataSource={listItems}
        onDelete={deleteItem}
        onCreate={createItem}
        onUpdate={updateItem}
      />
    </main>
  )
}

ItemsView.breadcrumb = () => (
  <Breadcrumb.Item key='breadcrumb-users' href='/items' active>
    Elementos
  </Breadcrumb.Item>
)

export default ItemsView
